import { put, takeEvery, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch,handleNotificationAlertTrySelect,handleNotificationAlertTryUpdate } from "../../../common/method/handleNotificationAlert";



 export const actionTypes={
    selectOptionPortfolio:"[selectOptionPortfolio] Action",
    selectOptionPortfoliopage:"[selectOptionPortfoliopage] Action",
    selectOptionPortfolioLoad:"[selectOptionPortfolioLaod] Action",
    selectOptionPortfolioPageAsync:"[selectOptionPortfolioPageAsync] Action",
    selectOptionPortfolioAsync:"[selectOptionPortfolioAsync] Action",
}


const initialState = {
    data:[],
    datapage:[],
    loading:false,
    total:0
}

 export const select_option_portfolio_reducer = (state=initialState,{type,payload})=>{
    switch (type) {
        case actionTypes.selectOptionPortfolio:
            return{
                ...state,
                data: payload?.data?.results ? payload?.data?.results :[],
                // total:payload?.data?.total ? payload?.data?.total :0
            }
        case actionTypes.selectOptionPortfoliopage:
            return{
                ...state,
                datapage: payload?.data?.results ? payload?.data?.results :[],
                total:payload?.data?.total ? payload?.data?.total :0
            }
        case actionTypes.selectOptionPortfolioLoad:
            return{
                ...state,
                loading:payload
            }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectOptionPortfolioLoad, payload: true });
    let config = {
        url: "select_request"
    };
    
    let data = {
        table: "portfolio",
        method_type: "select_option_portfolio",
        data: payload?.data ? payload.data : {},
    };
    
    try {
      let res = yield AxiosCustom(config, data);

      yield put({type:actionTypes.selectOptionPortfolio,payload:res.data.response})
    } catch {
      handleNotificationAlertCatch();
    }finally{
        yield put({ type: actionTypes.selectOptionPortfolioLoad, payload: false });

    }
  }


function* handleWorkerPage({ payload }) {
    // yield put({ type: actionTypes.selectOptionPortfolioLoad, payload: true });
    let config = {
        url: "select_request"
    };

    
    let data = {
        table: "portfolio",
        method_type: "select_option_portfolio",
        from:payload.from?payload.from:0,
        size:payload.size?payload.size:1000,
        data: payload?.data ? payload.data : {},
    };
    
    try {
        let res = yield AxiosCustom(config, data);
        
        yield put({type:actionTypes.selectOptionPortfoliopage,payload:res.data.response})
    } catch {
        handleNotificationAlertCatch();
    }finally{
        // yield put({ type: actionTypes.selectOptionPortfolioLoad, payload: false });
        
    }
}

export function* selectOptionPortfolio() {
      
      yield takeEvery(actionTypes.selectOptionPortfolioPageAsync, handleWorkerPage); 
    yield takeEvery(actionTypes.selectOptionPortfolioAsync, handleWorker);
  }